export default __webpack_public_path__ + "static/media/SUPPLIERS-1680x858.5aa5c259.png";